import React from 'react';
import { Icon } from '../../../subkit-ui';
import { ReadMore } from '../../ReadMore';
import { Parser } from 'html-to-react';
import { Socials } from '../../Socials';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ServiceIntro = function ServiceIntro(_ref) {
  var providerService = _ref.providerService,
      provider = _ref.provider;
  var avatarUrl = providerService.avatarUrl,
      location = providerService.location,
      description = providerService.description;
  var user = provider.user;
  var parser = new Parser();
  var desc = parser.parse(unescape(description));
  return /*#__PURE__*/_jsxs("div", {
    className: "service-intro flex flex-col lg:flex-row lg:w-3/5 w-full mx-auto h-2/6 mt-12",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "service-media flex flex-col items-center",
      children: [/*#__PURE__*/_jsx("div", {
        className: "service-avatar rounded-full",
        children: /*#__PURE__*/_jsx("img", {
          className: "object-cover rounded-full w-48 h-48",
          src: avatarUrl ? avatarUrl : '/images/img_avatar-placeholder.png',
          alt: "Service avatar"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "hidden lg:block lg:w-full",
        children: /*#__PURE__*/_jsx(Socials, {
          service: providerService,
          user: user
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "service-info w-full lg:ml-12 lg:mt-0 mt-8 lg:text-left text-center",
      children: [/*#__PURE__*/_jsx("h1", {
        className: "mt-0 mb-1 capitalize",
        children: providerService.name
      }), /*#__PURE__*/_jsxs("div", {
        className: "service-provider-info flex flex-col lg:flex-row",
        children: [/*#__PURE__*/_jsx("span", {
          className: "lg:mr-6 capitalize font-semibold",
          children: provider.name
        }), location && /*#__PURE__*/_jsxs("div", {
          className: "lg:mt-0 mt-2",
          children: [/*#__PURE__*/_jsx(Icon, {
            name: "map-marker-alt",
            className: "mr-1"
          }), /*#__PURE__*/_jsx("span", {
            children: location.fullAddress ? location.fullAddress : ''
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "hidden lg:block service-description w-full",
        children: /*#__PURE__*/_jsx(ReadMore, {
          description: desc,
          numberOfLines: 7
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "lg:hidden block",
      children: /*#__PURE__*/_jsx(Socials, {
        service: providerService,
        user: user
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "lg:hidden block service-description w-full",
      children: /*#__PURE__*/_jsx(ReadMore, {
        description: desc,
        numberOfLines: 7
      })
    })]
  });
};